// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/Claims/components/SiteTools.scss
// module id = 1244
// module chunks = 0